<template>
    <v-data-table
        :headers="headers"
        :items="items"
        item-key="id"
        hide-actions
        class="v-table--shrink shared-event-table"
    >
        <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td>{{ dateFormat(props.item.expirationDate) }}</td>
            <td class="text-center">
                <icon icon="share-solid" class="shared-event-table__icon" @click.native="openUrl(props.item.uri)"></icon>
            </td>
            <td class="text-center">
                <icon icon="link-solid" class="shared-event-table__icon" @click.native="copyToClipboard(props.item.uri)"></icon>
                <input type="hidden" :id="`hidden-url-${props.item.uri}`" :value="generateUrl(props.item.uri)">
            </td>
            <td class="text-center">
                <icon icon="edit-regular" class="shared-event-table__icon" @click.native="updateSharedEvent(props.item.id)"></icon>
            </td>
        </template>
    </v-data-table>
</template>

<script>
import { DeviceEventSharedApi } from '@/api'
import { formatDate } from '@/helpers/Utils'
import Icon from '@/components/atoms/Icon'
import toast from '@/plugins/izitoast'
import { mapActions } from 'vuex'
import { EMIT_EVENTS } from '@/config/consts'

const deviceEventSharedApi = new DeviceEventSharedApi()

export default {
    name: 'SharedEventTable',
    components: { Icon },
    async mounted () {
        this.setUpdateSharedEvent(null)
        await this.getSharedEvents()
        this.$root.$on(EMIT_EVENTS.SHARE_EVENT_CREATED, async (data) => {
            if (this.hardwareId === data) await this.getSharedEvents()
        })
    },
    data () {
        return {
            headers: [
                {
                    text: 'Name',
                    sortable: true,
                    value: 'name'
                },
                {
                    text: 'Expiration date',
                    sortable: true,
                    value: 'expiration_date'
                },
                {
                    text: 'URL',
                    sortable: false,
                    value: 'url'
                },
                {
                    text: 'Copy link',
                    sortable: false,
                    value: 'copy_link'
                },
                {
                    text: 'Edit',
                    sortable: false,
                    value: 'edit'
                }
            ],
            items: []
        }
    },
    props: {
        hardwareId: {
            type: String,
            required: true
        }
    },
    methods: {
        ...mapActions({
            setUpdateSharedEvent: 'trackingModule/setUpdateSharedEvent'
        }),
        async getSharedEvents () {
            const result = await deviceEventSharedApi.getDeviceEventsShared({
                hardwareId: this.hardwareId
            })

            this.items = result.payload.items
        },
        dateFormat (value) {
            return formatDate(value)
        },
        openUrl (uri) {
            let routeData = this.$router.resolve({ name: 'sharedEvent', params: { sharedUri: uri } })
            window.open(routeData.href, '_blank')
        },
        generateUrl (uri) {
            const link = this.$router.resolve({ name: 'sharedEvent', params: { sharedUri: uri } })
            return window.location.origin + link.resolved.path
        },
        copyToClipboard (uri) {
            let testingCodeToCopy = document.getElementById(`hidden-url-${uri}`)
            testingCodeToCopy.setAttribute('type', 'text')
            testingCodeToCopy.select()

            try {
                document.execCommand('copy')
                toast.success('Link copied to the clipboard')
            } catch (err) {
                toast.error('Cannot copied this link to the clipboard')
            }

            testingCodeToCopy.setAttribute('type', 'hidden')
            window.getSelection().removeAllRanges()
        },
        updateSharedEvent (id) {
            this.setUpdateSharedEvent(id)
        }
    }
}
</script>

<style scoped lang="scss">
.shared-event-table {
    &__icon {
        cursor: pointer;
        color: $inactive;

        &:hover {
            opacity: 0.7;
        }
    }
    .text-center {
        text-align: center;
    }
}
</style>
